import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const isLoggedIn = localStorage.getItem("token") === "true";

  useEffect(() => {
    console.log(isLoggedIn, "isLoggedIn");
  }, [isLoggedIn]);

  const LogOut = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/";
  };
  return (
    <div className="header">
      <a href="/">
        <h1>Resource Library</h1>
      </a>
      <a
        className="logout btn"
        href="https://www.dearfuturehuman.us"
        target="_blank"
      >
        HOME
      </a>
      {/* {isLoggedIn ? <button className="logout btn" onClick={LogOut}>Log out</button> : <a className="btn" href="/login">Login</a> }  */}
    </div>
  );
};

export default Header;
